import { GoogleLogin } from '@react-oauth/google';
import Cookies from 'js-cookie';
import { FC } from 'react';
import useAuthStore from '../../../store/useAuthStore';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../../utils/helpers';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { IProfile } from '../../../types';

const Login: FC = () => {
  const { setAuth, setProfile } = useAuthStore();
  const navigate = useNavigate();

  const verifyToken = (token: string) => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}api/v1/auth/token/google?token=${token}`)
      .then((res) => {
        if (res.data) {
          const credentials = jwtDecode(token);
          Cookies.set('_token', res.data);
          Cookies.set('_profile', JSON.stringify(credentials));
          setProfile(credentials as IProfile);
          setAuth(true);
          navigate('/', { replace: true });
        }
      })
      .catch(console.log);
  };

  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className={cn('p-8', 'border border-gray', 'rounded-2xl')}>
        <GoogleLogin
          onSuccess={(credentialResponse) => {
            if (credentialResponse.credential) {
              verifyToken(credentialResponse.credential);
            }
          }}
          onError={() => {
            console.log('Login Failed');
          }}
        />
      </div>
    </div>
  );
};

export default Login;
